var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.79225 2.6519C7.40176 4.11046 4.92924 6.70137 3.29786 8.40949C-0.13099 11.9997 0.000669661 11.823 0.000669661 12.8336C0.000669661 13.695 0.0877486 13.8466 1.33474 15.1552C1.89706 15.7452 2.375 16.2165 2.39687 16.2025C2.41874 16.1884 2.45188 16.0612 2.47054 15.9198C2.52002 15.5446 2.71351 15.0452 2.94989 14.6827C3.19196 14.3114 4.32668 13.1052 10.1325 7.04762L14.4143 2.58L17.4089 2.56489L20.4035 2.54971V1.28986V0.0300022L15.8619 0.0150011L11.3204 0L8.79225 2.6519ZM12.3158 6.49006C10.8793 7.99696 8.41626 10.5747 6.84254 12.2184C4.17428 15.0052 3.96862 15.2345 3.79452 15.617C3.62391 15.9918 3.60779 16.0753 3.60779 16.5839C3.60779 17.5699 3.42992 17.3393 7.18713 21.2243C10.9733 25.1392 10.7958 24.9927 11.7507 24.9927C12.7238 24.9927 12.2056 25.4593 18.473 18.9398L23.9769 13.2145L23.9884 8.49739L24 3.78026L19.4639 3.76526L14.9277 3.75026L12.3158 6.49006ZM21.0779 6.06646C22.2259 6.64371 22.2407 8.30988 21.1031 8.90084C20.8321 9.04165 20.6777 9.08337 20.4276 9.08337C19.7812 9.08337 19.1426 8.57515 18.9681 7.92178C18.7583 7.13675 19.1821 6.29798 19.9422 5.99374C20.1966 5.89195 20.8088 5.93116 21.0779 6.06646Z",
    fill: "#A7388E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTags);
export default __webpack_public_path__ + "static/media/iconTags.c31920dd8eb8f12ce4c3e3a3113169ff.svg";
export { ForwardRef as ReactComponent };